// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as Environments$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/Environments.mjs";
import * as OrderHistoryRepo$PorterinFeature from "./OrderHistoryRepo.mjs";
import * as DummyOrderHistoryRepo$PorterinFeature from "./DummyOrderHistoryRepo.mjs";
import * as DummyOrderHistoryContentRepo$PorterinFeature from "./DummyOrderHistoryContentRepo.mjs";

function getRepo(param) {
  if (Config$PorterinUtils.env === Environments$PorterinUtils.development) {
    return DummyOrderHistoryRepo$PorterinFeature;
  } else {
    return {
            orderHistory: OrderHistoryRepo$PorterinFeature.orderHistory
          };
  }
}

function getContentRepo(param) {
  if (Config$PorterinUtils.env === Environments$PorterinUtils.development) {
    return DummyOrderHistoryContentRepo$PorterinFeature;
  } else {
    return OrderHistoryRepo$PorterinFeature;
  }
}

export {
  getRepo ,
  getContentRepo ,
}
/* Config-PorterinUtils Not a pure module */
